import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { tooltipStyle } from './CopyTooltip.style';
import { Button } from '../Button';
import { colorPalette } from '../../colorPalette';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
export const CopyTooltip = ({ dataQa, dataToCopy, children, title }) => {
    const [openTooltip, setOpenTooltip] = useState(false);
    const handleClick = () => {
        navigator.clipboard.writeText(dataToCopy).then(() => {
            setOpenTooltip(true);
            setTimeout(() => {
                setOpenTooltip(false);
            }, 1000);
        });
    };
    return (React.createElement(Box, { "data-qa": dataQa },
        React.createElement(Tooltip, { arrow: true, placement: "right", title: React.createElement(Box, { "data-qa": `${dataQa}-tooltip` }, title ? title : 'Copié'), PopperProps: {
                disablePortal: true,
                sx: tooltipStyle,
            }, componentsProps: {
                arrow: { sx: { color: colorPalette.gray900 } },
            }, open: openTooltip },
            React.createElement(Button, { "data-qa": `${dataQa}-button`, onClick: handleClick, sx: {
                    padding: 0,
                    minWidth: 'auto',
                    ml: 1,
                }, color: "tertiary" }, children ? children : React.createElement(ContentCopyOutlinedIcon, { sx: { fontSize: '1.8rem', color: colorPalette.gray600 } })))));
};
